<template>
    <b-row v-if="status === null || status === ''">
        <b-col sm="12">
            <b-card>
                <b-row class="pt-2">
                    <b-col sm="12" style="text-align: center;">
                        구독회원이 아닙니다.
                    </b-col>
                </b-row>
            </b-card>
        </b-col>
    </b-row>
    <b-row v-else>
        <b-col sm="12">
            <b-card>
                <div slot="header">
                    <span class="card-title wise-card-title">권한키 관리</span>
                </div>
                <b-row>
                    <b-col sm="12">
                        <table class="table table-bordered keyAuth">
                            <thead>
                                <tr>
                                    <th scope="col" style="width: 33%;">권한키 수량</th>
                                    <th scope="col" style="width: 33%;">사용중인 수량</th>
                                    <th scope="col" style="width: 33%;">잔여수량</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <div style="width: 100%;display: inline-flex;">
                                            <template v-if="isModify">
                                                <div style="width: 50%;">
                                                    <input type="text" 
                                                            v-model="modifyStatus.key_cnt" 
                                                            class="form-control" />
                                                </div>
                                                <div style="margin: 3px 0 0 0; width: 50%;">
                                                    <b-button variant="primary btn-sm" v-on:click="saveKeyCnt">저장</b-button>
                                                    <b-button variant="danger btn-sm" v-on:click="modifyView">취소</b-button>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <div style="width: 50%; text-align: right;">
                                                    {{ status.key_cnt }}
                                                </div>
                                                <div style="width: 45%;">
                                                    <b-button variant="primary btn-sm" v-on:click="modifyView">수정</b-button>
                                                </div>
                                            </template>
                                        </div>
                                    </td>
                                    <td>{{ status.use_key_cnt }}</td>
                                    <td>{{ status.limit_key_cnt }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </b-col>
                </b-row>
            </b-card>
            <b-card>
                <div slot="header">
                    <span class="card-title wise-card-title">권한키 적용 내역</span>
                </div>
                <b-row>
                    <b-col sm="12">
                        <b-table outlined
                                :fields="fields"
                                :items="items"
                                :busy="items == 0"
                                :current-page="currentPage"
                                :per-page="perPage">
                                <div slot="table-busy" class="text-center my-2">
                                    <strong>데이터가 없습니다.</strong>
                                </div>
                                <template slot="empty" slot-scope="row">
                                    <b-button variant="danger btn-sm" v-on:click="deleteKey(row.item)">삭제</b-button>
                                </template>
                        </b-table>
                        <!-- <b-col>
                            <b-pagination
                            v-model="currentPage"
                            :totalRows="totalRows"
                            :per-page="perPage"
                            align="center"
                            ></b-pagination>
                        </b-col> -->
                    </b-col>
                </b-row>
            </b-card>
        </b-col>
    </b-row>
</template>
<script>
import swal from 'sweetalert2'
import _ from 'lodash'

export default {
    name: "userAuthKeyDetail",
    props: {
        userId: {
            type: String,
            default: ""
        },
    },
    watch: {
        userId: function (value, oldValue) {
            this.findCompanyKeyInfo();
            this.findUserKeyList();
        },
        'modifyStatus.key_cnt': function (value, oldValue) {
            this.modifyStatus.key_cnt = value.replace(/[^0-9]/g,'');
        },
    },
    data() {
        return {
            currentPage: 1,
            perPage:100,
            totalRows:0,
            fields: [
                {'name': {'label': '계정사용자', thClass: 'thClass_w10', tdClass: 'textAlignCenter'}}
                , {'user_id': {'label': '계정 E-Mail', thClass: 'thClass_w15', tdClass: 'textAlignCenter'}}
                , {'key_code': {'label': 'Key Code', thClass: 'thClass_w15', tdClass: 'textAlignCenter'}}
                , {'ip': {'label': 'IP', thClass: 'thClass_w08', tdClass: 'textAlignCenter'}}
                , {'auth_user_name': {'label': '키 사용자', thClass: 'thClass_w15', tdClass: 'textAlignCenter'}}
                , {'department_name': {'label': '부서명', thClass: 'thClass_w15', tdClass: 'textAlignCenter'}}
                , {'mac': {'label': 'MAC', thClass: 'thClass_w15', tdClass: 'textAlignCenter'}}
                , {'empty': {'label': '삭제', thClass: 'thClass_w10', tdClass: 'textAlignCenter'}}
            ],
            items: [],
            status: {},
            modifyStatus: {},
            isModify: false,
        }
    },
    methods: {
        findCompanyKeyInfo() {
            var token = sessionStorage.getItem("myToken");
            this.$http.get('/api/select/getAuthKeyCnt?access_token='+token + '&user_id=' + this.userId)
                .then((result) => {
                    this.status = {};
                    this.modifyStatus = {};

                    const { data } = result;
                    this.status = data;

                    this.modifyStatus = _.cloneDeep(data);
            })
        },
        findUserKeyList() {
            var token = sessionStorage.getItem("myToken");
            this.$http.get('/api/select/userKeyList?access_token='+token + '&user_id=' + this.userId)
                .then((result) => {
                    this.items = [];

                    const { data } = result;
                    this.items = data;
            })
        },
        modifyView() {
            this.isModify = !this.isModify;
        },
        deleteKey(data) {
            // /api/select/deleteUserAuthKey

            swal.fire({
                title: '권한키 삭제',
                text: "키사용자 " + data.auth_user_name + " 님을 삭제 하시겠습니까?",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'OK'
              }).then((swalResult) => {
                if (swalResult.value) {
                    var token = sessionStorage.getItem("myToken");

                    this.$http.get('/api/select/deleteUserAuthKey?access_token=' + token + '&user_id=' + this.userId + "&key_code=" + data.key_code)
                        .then((result) => {
                            const { data } = result;
                            if(data === 'ok'){
                                swal.fire({
                                    type: 'success',
                                    title: '수정 완료 하였습니다.',
                                    showConfirmButton: false,
                                    timer: 1500
                                })

                                this.findUserKeyList();
                            }else{
                                swal.fire({
                                    type: 'error',
                                    title: '수정 중 오류가 발생하였습니다.',
                                    showConfirmButton: false,
                                    timer: 1500
                                })
                            }
                    });
                }
            });

            // console.log('deleteKey', data);
        },
        saveKeyCnt(data) {
            if(this.modifyStatus.key_cnt === null || this.modifyStatus.key_cnt === '' || this.modifyStatus.key_cnt < 3){
                swal.fire({
                    type: 'error',
                    title: '키수량은 최소 3개 이상 입력하여주세요.',
                    showConfirmButton: false,
                    timer: 1500
                })
            }else if( this.modifyStatus.key_cnt < this.modifyStatus.use_key_cnt){
                swal.fire({
                    type: 'error',
                    title: '현재 사용중인 수량보다 작습니다.',
                    showConfirmButton: false,
                    timer: 1500
                })
            }else{
                swal.fire({
                    title: '권한키 수량 변경',
                    text: "해당 사용자의 권한키 수량을 변경 하시겠습니까?",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'OK'
                  }).then((swalResult) => {
                    if (swalResult.value) {
                        var token = sessionStorage.getItem("myToken");
    
                        this.$http.get('/api/update/updateOderKeyCnt?access_token=' + token + '&user_id=' + this.userId + "&order_code=" + this.status.order_code + "&key_cnt=" + this.modifyStatus.key_cnt)
                            .then((result) => {
                                const { data } = result;
                                if(data === 'ok'){
                                    swal.fire({
                                        type: 'success',
                                        title: '수정 완료 하였습니다.',
                                        showConfirmButton: false,
                                        timer: 1500
                                    })
                                    this.findCompanyKeyInfo();
                                    this.modifyView();
                                }else{
                                    swal.fire({
                                        type: 'error',
                                        title: '수정 중 오류가 발생하였습니다.',
                                        showConfirmButton: false,
                                        timer: 1500
                                    })
                                }
                        });
                    }
                });
            }
            // console.log('saveKeyCnt', this.modifyStatus.key_cnt);
        }
    },
}
</script>
<style lang="css" scoped>
.keyAuth thead tr th {
    background: #dcdcdc;
    text-align: center;
}
.keyAuth tbody tr td {
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/views/user/userDetail/component/tabs/authKey/UserAuthKeyDetail.vue